import { useState } from 'react';
import UploadFileDialog from './UploadFileDialog';
import { ListFiles } from './ListFiles';
import { File } from '@/__generated__/graphql';
import { useSaveAssemblyAttachment } from '../hooks/useSaveAssemblyAttachment';
import { MediaActionButtons } from '@/components/shared/MediaActionButtons';
import { Attachment } from '@/components/shared/AttachmentDisplay/type';

type Props = {
  referenceId: string;
  collectionName: string;
  files: File[];
  children?: React.ReactNode;
};

export const FileUploadAndViewer = ({ files, referenceId, collectionName, children }: Props) => {
  const [openFileDialog, setOpenFileDialog] = useState<boolean>(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [attachments, setAttachments] = useState<Attachment[]>([]);
  const { handleCaptureScreenshot } = useSaveAssemblyAttachment(
    referenceId,
    collectionName,
    setIsUpdating
  );

  const dialogTitle = 'Attachments';
  const buttonText = 'Add';

  const handleDialogToggle = () => setOpenFileDialog(!openFileDialog);

  return (
    <>
      <MediaActionButtons
        isUpdating={isUpdating}
        onUploadClick={handleDialogToggle}
        onCaptureClick={handleCaptureScreenshot}
      >
        {children}
      </MediaActionButtons>
      <ListFiles
        attachments={attachments}
        setAttachments={setAttachments}
        referenceId={referenceId}
        collectionName={collectionName}
        files={files}
        setIsUpdating={setIsUpdating}
      />
      <UploadFileDialog
        openDialog={openFileDialog}
        setOpenDialog={setOpenFileDialog}
        referenceId={referenceId}
        collectionName={collectionName}
        attachments={attachments}
        dialogTitle={dialogTitle}
        buttonText={buttonText}
        setAttachments={setAttachments}
        setIsUpdating={setIsUpdating}
      />
    </>
  );
};
